import "./MoreInformation.css";
import vestingDurationImage from "../../img/vestingDuration.png";

export const VestingDuration = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column flex flex-column">
      <text className="sub-title">Vesting period</text>
      <text className="paragraph">
        The vesting period for founders refers to the length of time that the
        founder must work for the company before they have earned all of their
        equity (shares) in the company. The vesting period is meant to
        incentivize the founders to remain with the company and to continue
        making contributions to its success.
      </text>
      <text className="paragraph">
        During the vesting period, the founder’s shares gradually vest over
        time, usually on a monthly or quarterly basis (to be chosen in the
        frequency section), according to the vesting schedule.
      </text>
      <text className="sub-title mt-4">Duration of the vesting period</text>
      <text className="paragraph">
        The most common vesting duration would be 4 years. However different
        factors could motivate to agree on a shorter or longer duration. One of
        the most important elements to consider is whether or not a founder is
        still fundamentally needed at the company during the vesting period. In
        a perfect scenario the founders have become replaceable due to their own
        efforts in the vesting period. They have thus ‘earned’ their shares and
        should not be penalized anymore on their shares.
      </text>
      <text className="paragraph">
        The longer the vesting period, the greater the commitment and the
        stronger the incentive to stay & work for the company.
      </text>
    </div>
    <div className="info-column flex">
      <img src={vestingDurationImage} className="info-image mr-auto ml-auto" />
    </div>
  </div>
);
